<tsmt-loader *ngIf="showLoader"></tsmt-loader>
<form class="t-section" [formGroup]="keyTeamMemberForm">
    <div class="t-section-header">
        <div class="t-section-title">Key Team Members</div>
    </div>
    <div class="t-section-body">
        <div class="flex flex-wrap pl-4 align-key-team-members">
            <div class="col-span-3">
                <div class="row mb-1">
                    <div class="col-span-12 pl-3">
                        <label> Project Manager:</label>
                    </div>
                    <div class="col-span-12 pl-3">
                        <tsmt-active-directory formControlName="projectMgrName" ngDefaultControl [mode]="formMode"
                            #projectMgrName [isMandatory]="isMandatory" [isFormEditable]="isFormEditable"
                            [defaultManagerName]="projectManagerName" [requireLocalAccount]="true"
                            (formUpdate)="setProjectManagerName($event.form,$event.selectedData)"
                            [doesUserHasEditAccess]="isFormEditable">
                        </tsmt-active-directory>
                    </div>
                </div>
            </div>
            <div class="col-span-3">
                <div class="row mb-1">
                    <div class="col-span-12 pl-3">
                        <label> Sales Manager:</label>
                    </div>
                    <div class="col-span-12 pl-3">
                        <tsmt-active-directory formControlName="salesMgrName" ngDefaultControl [mode]="formMode"
                            #salesMgrName [isMandatory]="isMandatory" [isFormEditable]="isFormEditable"
                            [defaultManagerName]="salesManagerName"
                            (formUpdate)="setSalesManagerName($event.form,$event.selectedData)"
                            [doesUserHasEditAccess]="isFormEditable">
                        </tsmt-active-directory>
                    </div>
                </div>
            </div>
            <div class="col-span-2">
                <div class="row mb-1">
                    <div class="col-span-12 pl-3"></div>
                    <div class="col-span-12 pl-3 mt-3">
                        <button class="t-btn t-btn-primary" (click)="saveCreditProjectPreference()"><span
                                class="t-icon"><em class="fas fa-save"></em></span>SAVE</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
